module.exports = __webpack_public_path__ + "static/media/heart2.6888b18c.png";